import React from "react"
import { useBlocks } from "app/regions/hooks/use-blocks"
import { useEditing } from "app/regions/hooks/use-editing"
import { BlockIcon } from "./icon"
import Icon from "@kit/design/icon"
import { Block } from "../shared/block"

export function Icons({ id }) {
  const { properties, children, add } = useBlocks(id)
  const editing = useEditing()

  const addIcon = () => add({ type: "icon" })

  return (
    <Block
      id={id}
      style={{
        textAlign: properties.alignment,
        marginTop: 16,
        marginBottom: 16
      }}
      data-block-id={id}
    >
      {children.map(icon => (
        <BlockIcon
          key={icon.block_id}
          data={icon}
          foreground={properties.foreground}
          background={properties.background}
          shape={properties.shape}
        />
      ))}
      {editing && <AddIcon onClick={addIcon} shape={properties.shape} />}
    </Block>
  )
}

function AddIcon({ onClick, shape }) {
  const borderRadius = shape === "circle" ? 16 : 4

  return (
    <button
      onClick={onClick}
      style={{ width: 32, height: 32, borderRadius }}
      className="bg-gray-100 inline-block align-middle hover:bg-gray-200 hover:text-gray-900 transition-colors duration-200"
    >
      <Icon name="plus" />
    </button>
  )
}
